import tailwindConfig from 'tailwind.config'
import resolveConfig from 'tailwindcss/resolveConfig'

/**
 * Tailwind configuration defined in `tailwind.config.ts`.
 */
export const twConfig = resolveConfig(tailwindConfig)
